import { render, staticRenderFns } from "./RoomBoxBattle.vue?vue&type=template&id=788264d7&scoped=true&"
import script from "./RoomBoxBattle.vue?vue&type=script&lang=js&"
export * from "./RoomBoxBattle.vue?vue&type=script&lang=js&"
import style0 from "./RoomBoxBattle.vue?vue&type=style&index=0&id=788264d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788264d7",
  null
  
)

export default component.exports